module.exports = __webpack_public_path__ + "static/media/1.Reaper.1e8ab14d.jpg";